import { Typography } from '@mui/material';
import { theme } from '@theguarantors/tg-package-material-ui';
import { InviteLeaseDetailsDrawerForm } from './invite-lease-details.drawer.form';
import { useInviteLeaseDetailsController } from './hooks';
import { Renter } from '@/utils/types/renter.interface';
import type { InviteFlowMilestoneKey } from './types';

export type InviteLeaseDetailsDrawerFormContentProps = {
  onSuccess?: (renter: Renter) => void;
  onMilestoneReached?: (key: InviteFlowMilestoneKey) => void;
};

export const InviteLeaseDetailsDrawerFormContent = ({
  onSuccess,
  onMilestoneReached,
}: InviteLeaseDetailsDrawerFormContentProps) => {
  const { user, errorMsg, isSmbInvite, useNewForm, customCoverageDisabled, onSubmit } =
    useInviteLeaseDetailsController({ onSuccess });

  return (
    <>
      <Typography
        mb={3}
        letterSpacing={0}
        sx={{
          fontSize: '16px !important',
          [theme.breakpoints.down('md')]: {
            fontSize: '14px !important',
            lineHeight: '22px',
          },
        }}
      >
        Please fill out your applicant's information below, and we will send them an invitation to
        apply using the email address provided.
      </Typography>
      <InviteLeaseDetailsDrawerForm
        user={user}
        onSubmit={onSubmit}
        errorMsg={errorMsg}
        newCoveragesEnabled={useNewForm}
        customCoverageDisabled={customCoverageDisabled}
        isSmbInvite={isSmbInvite}
        onMilestoneReached={onMilestoneReached}
      />
    </>
  );
};
